import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ZoomLevelService } from './zoom-level.service';
import { ModuleConfigService } from './module-config.service';

@Injectable({
    providedIn: 'root',
})
export class HeadlineService {
    headline: string[];
    idString = '';
    isMainPage: boolean;
    showCheckbox: boolean = true;

    enabled: boolean = true;
    showIframe: boolean;

    checkboxChanged = new Subject<void>();

    /**
     * Runtime state for each module's iframe visibility.
     * Initialized from module-config.json defaults at app startup.
     * Toggled at runtime when user clicks the "Alt" checkbox.
     */
    moduleStates: Record<string, boolean> = {};

    constructor(
        private zoomLevelService: ZoomLevelService,
        private moduleConfigService: ModuleConfigService
    ) {
        const config = this.moduleConfigService.config;
        for (const [moduleId, moduleConfig] of Object.entries(config)) {
            this.moduleStates[moduleId] = moduleConfig.showIframe;
        }
    }

    setHeadline(
        headline: (string | undefined)[],
        idString: string,
        isMainPage = true,
        showCheckbox = true
    ) {
        setTimeout(() => {
            this.headline = headline.filter(
                (h): h is string => h !== undefined
            );
            this.idString = idString;
            this.isMainPage = isMainPage;
            this.showCheckbox = showCheckbox;

            const config = this.moduleConfigService.getConfig(idString);
            this.enabled = config?.enableToggle ?? false;
            this.showIframe =
                this.moduleStates[idString] ?? config?.showIframe ?? false;
        }, 1);
    }

    toggleOldSystem() {
        if (this.showIframe) {
            this.zoomLevelService.changeZoom();
        }
        this.moduleStates[this.idString] = this.showIframe;
        this.checkboxChanged.next();
    }
}
